<template>
    <!-- Theme one -->
    <div v-if="themeStore.themeIndex === 1">
        <div v-if="show">
            <ProfilePopupOne v-modal="show" :data-set="dataSet" @click-banner="clickBanner" @close="close" />
        </div>
    </div>
    <!-- Theme two -->
    <div v-if="themeStore.themeIndex === 2">
        <div v-if="show">
            <ProfilePopupTwo v-modal="show" :data-set="dataSet" @click-banner="clickBanner" @close="close" />
        </div>
    </div>

</template>

<script setup lang="ts">
import { ref, defineExpose, defineEmits, computed } from 'vue'
import { useUserStore } from '@/stores/user'
import { ProfilePoupData } from './supportScript';
import ProfilePopupOne from '@/themes/themeOne/profile/profilePopup.vue';
import ProfilePopupTwo from '@/themes/themeTwo/profile/profilePopup.vue';
import { HOME_COMPONENT_ID } from '../home/supportScript';
import { useThemeStore } from '@/stores/theme';

const userStore = useUserStore()
const themeStore = useThemeStore();
const componentIdsInOrderConfig = ref(HOME_COMPONENT_ID);
const show = ref(false)
const isPopping = ref(false)
const componentList = ref([])

const dataSet = computed<ProfilePoupData>(() => ({
    show: show.value,
    isPopping: isPopping.value,
    componentList: componentList.value,
    componentIdsInOrderConfig: componentIdsInOrderConfig.value,
}))

const open = (list: any) => {
    console.log('open');

    componentList.value = list
    show.value = true
    userStore.getInfo()
}
const emits = defineEmits(['openAgentPopup'])
const close = () => {
    show.value = false
}
const clickBanner = () => {
    isPopping.value = true
    setTimeout(() => {
        isPopping.value = false
        emits('openAgentPopup')
    }, 300)

}

defineExpose({
    open,
    close
})

</script>